export default __webpack_public_path__ + "/assets/nav_default_foglia.png";